/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Xing",
  size: 20
}

const SvgXing = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M4.4 4.56c-.16 0-.29.05-.35.16-.07.11-.06.25.02.4l1.75 3.04v.01l-2.76 4.87c-.07.14-.07.29 0 .4.06.11.18.18.34.18H6c.39 0 .57-.26.71-.5 0 0 2.7-4.77 2.8-4.96-.02-.02-1.79-3.12-1.79-3.12-.14-.23-.33-.48-.73-.48H4.4zM15.3 1c-.39 0-.56.25-.7.5 0 0-5.59 9.92-5.78 10.24l3.69 6.77c.13.23.33.49.72.49h2.59c.16 0 .28-.06.34-.17.07-.11.07-.26 0-.4l-3.66-6.69v-.02l5.75-10.16c.07-.14.07-.29 0-.4-.04-.1-.17-.16-.32-.16H15.3z" />
  </Svg>
)

SvgXing.defaultProps = defaultProps
export default SvgXing
